import React from "react";
import { classNames } from "./utils/classNames";
import { IconOptions } from "./utils/iconOptions";
export const Steps = ({ children }) => {
    return React.createElement("div", { className: "steps" }, children);
};
export const Step = ({ title, active, complete, glyph, }) => {
    const iconType = glyph && IconOptions[glyph].type === "pro" ? "glyphicon-pro" : "glyphicon";
    const iconValue = glyph && IconOptions[glyph].value;
    return (React.createElement("div", { className: classNames("step", active ? "step--active" : "", complete ? "step--complete" : "") },
        React.createElement("div", { className: "step--title" },
            glyph && (React.createElement("span", { className: `icon ${iconType} ${iconType}-${iconValue}` })),
            React.createElement("div", { className: "step--circle" }),
            React.createElement("p", null, title))));
};
